import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

export type ContactTopic = 'general' | 'snapcart';

export interface ContactFormValue {
    topic: ContactTopic;
    name: string;
    email: string;
    company?: string;
    os?: string;
    mac?: string;
    message: string;
}

/** The closed anonymous body: schemaId travels in the path, `contentSchema` is NOT a body field. */
interface PortalFormSubmission {
    title: string;
    description: string;
    content: string;
}

@Injectable({ providedIn: 'root' })
export class ContactService {
    constructor(private http: HttpClient) { }

    /**
     * POST /portal/forms/{schemaId}/submissions on the anonymous cms tier. No bearer, ever: a token that
     * is merely present is validated and 401s on a permit path. The topic picks the schema and the tenant
     * (general enquiries → the site tenant; Snapcart access requests → `snapcartAccessFormTenantId`).
     */
    submit(v: ContactFormValue): Observable<unknown> {
        const env = environment as any;
        const base: string = env.formsApiUrl;
        const snapcart = v.topic === 'snapcart';
        const schemaId: number = snapcart ? env.snapcartAccessFormSchemaId : env.contactFormSchemaId;
        const tenantId: string = snapcart ? env.snapcartAccessFormTenantId : env.tenantId;

        const answers: Record<string, string> = { name: v.name, email: v.email, company: v.company || '', message: v.message || '' };
        const display: Record<string, string> = { 'Name': v.name, 'Email': v.email, 'Company': v.company || '', 'Message': v.message || '' };
        if (snapcart) {
            answers['os'] = v.os || '';
            answers['mac'] = v.mac || '';
            display['Operating system'] = v.os || '';
            display['MAC address'] = v.mac || '';
        }
        const body: PortalFormSubmission = {
            title: snapcart ? `Snapcart access — ${v.name}` : `Contact — ${v.name}`,
            description: (snapcart ? `${v.os || ''} ${v.mac || ''} ${v.message || ''}` : v.message).trim().slice(0, 140),
            content: JSON.stringify({ answersByLocale: { en: answers }, displayByLocale: { en: display } })
        };
        return this.http.post(`${base}/portal/forms/${schemaId}/submissions`, body, { headers: new HttpHeaders({ tenantId }) });
    }
}
